import React from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Spinner } from '@salesforce/design-system-react/';

import * as I18nActions from '../actions';
import messages from '../messages';

class Intl extends React.Component {
  componentDidMount() {
    this.props.actions.getLocale({ locale: this.props.locale });
  }

  componentDidUpdate(prevProps) {
    if (this.props.locale !== prevProps.locale)
      this.props.actions.getLocale({ locale: this.props.locale });
  }

  renderSpinnerOrChildren(isLoading) {
    return isLoading ? (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    ) : (
      this.props.children
    );
  }

  render() {
    const { isLoading, locale, messages } = this.props;
    return (
      <IntlProvider locale={locale} messages={messages}>
        {this.renderSpinnerOrChildren(isLoading)}
      </IntlProvider>
    );
  }
}

Intl.defaultProps = {
  locale: 'en',
  messages: messages.en,
  isLoading: true
};

Intl.propTypes = {
  actions: PropTypes.shape({
    getLocale: PropTypes.func.isRequired
  }).isRequired,
  children: PropTypes.element,
  locale: PropTypes.string,
  messages: PropTypes.object,
  isLoading: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    locale: state.i18n.locale,
    messages: state.i18n.messages,
    isLoading: state.i18n.isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(I18nActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Intl);
